import script from "./6.SkinType.vue?vue&type=script&setup=true&lang=ts"
export * from "./6.SkinType.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__